import { c as _c } from "react/compiler-runtime";
import MapAtomPopupCluster from "./MapAtomPopupCluster";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { useMapListCluster } from "./useMapListCluster";
import { useTranslations } from "next-intl";
type Props = {
  lat: number;
  lng: number;
  realEstateIds?: string[];
};
export function MapListCluster(props) {
  const $ = _c(22);
  const {
    containerRef,
    sortedData,
    isLoading,
    listEndRef,
    totalItems,
    isMobile,
    isHighlighted
  } = useMapListCluster(props);
  const tCluster = useTranslations("modules.search.map.cluster");
  if (!sortedData || isLoading) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="h-full flex items-center justify-center"><Loader2 className="animate-spin text-muted-foreground" /></div>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== tCluster || $[2] !== totalItems) {
    t0 = totalItems === 1 ? tCluster("propertySingular", {
      count: totalItems
    }) : tCluster("propertyPlural", {
      count: totalItems
    });
    $[1] = tCluster;
    $[2] = totalItems;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== t0) {
    t1 = <h3 className="text-lg font-bold mb-1 ml-1 text-foreground">{t0}</h3>;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== isHighlighted || $[7] !== isMobile || $[8] !== sortedData) {
    let t3;
    if ($[10] !== isHighlighted || $[11] !== isMobile) {
      t3 = (node, idx) => <div key={`popup-item-${idx}`} className={cn("p-2 cursor-pointer hover:bg-muted transition-colors duration-150", isHighlighted(node) && "border-2 border-primary rounded-lg bg-primary/5")}><MapAtomPopupCluster isMobile={isMobile} node={node} /></div>;
      $[10] = isHighlighted;
      $[11] = isMobile;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    t2 = sortedData.map(t3);
    $[6] = isHighlighted;
    $[7] = isMobile;
    $[8] = sortedData;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[13] !== listEndRef) {
    t3 = <div ref={listEndRef} />;
    $[13] = listEndRef;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== containerRef || $[16] !== t2 || $[17] !== t3) {
    t4 = <div ref={containerRef} className="max-h-[40vh] md:max-h-[45vh] min-h-[20vh] md:min-h-[25vh] w-full overflow-y-auto divide-y divide-border themed-scrollbar">{t2}{t3}</div>;
    $[15] = containerRef;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== t1 || $[20] !== t4) {
    t5 = <>{t1}{t4}</>;
    $[19] = t1;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
}